import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { WarehouseAxios } from "api/WarehouseAxios";
import { api } from "helpers/api_url";

interface ExportFilters {
  search?: string;
  warehouse_id?: string;
  date_from?: string;
  date_to?: string;
  page?: number;
  pageSize?: number;
  sort?: string;
  order?: "asc" | "desc";
  [key: string]: any; // any extra filters
}

export const fetchReadyForDispatch = createAsyncThunk(
  "ReadyForDispatch/fetchReadyForDispatch",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
    warehouse_id,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
    warehouse_id: string;
  }) => {
    const params = new URLSearchParams();

    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());

    if (search) params.append("search", search);

    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    // Helper
    const formatDate = (date: any) => {
      if (!date) return "";
      const d = new Date(date);
      return d.toISOString().split("T")[0]; // ALWAYS YYYY-MM-DD, no timezone issues
    };

    // Apply filters
    if (filters?.length) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (!filterField || filterValue === undefined || filterValue === null)
            return;

          // 🗓 Handle date-range filters (object with from_date / to_date)
          if (typeof filterValue === "object" && filterValue !== null) {
            const { from_date, to_date } = filterValue;

            // Created / Updated / Order Date → same pattern as ORDER API
            if (
              from_date &&
              (filterField === "created_at" ||
                filterField === "updated_at" ||
                filterField === "order_date")
            ) {
             params.append(`${filterField}_from`, formatDate(from_date));


            }

            if (
              to_date &&
              (filterField === "created_at" ||
                filterField === "updated_at" ||
                filterField === "order_date")
            ) {
             params.append(`${filterField}_to`, formatDate(to_date));
            }

            return; // Stop processing here
          }

          // 🔤 Simple filters (string, number)
          params.append(filterField, String(filterValue));
        }
      );
    }
    // API CALL
    const response: any = await Axios.get(
      `${
        api.warehouse.dispatch.ready_for_dispatch.listing
      }?dispatch_from_warehouse_id=${warehouse_id}&${params.toString()}`
    );

    return {
      data: response?.data?.data || [],
      rowCount: response?.data?.count || 0,
    };
  }
);


// CSV Export 
export const exportReadyForDispatchCSV = async (filters: ExportFilters = {}) => {
  // Build query parameters from filters
  const params = new URLSearchParams({ export: "csv", ...filters } as any);

  const response = await Axios.get(
    `${api.warehouse.dispatch.ready_for_dispatch.export_csv}?${params.toString()}`,
    {
      responseType: "blob",
    }
  );

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "readyForDispatch.csv",
  };
};

// CSV EXPORT
// export const exportReadyForDispatchCSV = async () => {
//   const response = await Axios.get(
//     api.warehouse.dispatch.ready_for_dispatch.export_csv,
//     {
//       responseType: "blob",
//     }
//   );

//   return {
//     blob: response.data,
//     filename:
//       response.headers["content-disposition"]
//         ?.split("filename=")[1]
//         ?.replace(/"/g, "") || "readyForDispatch.csv",
//   };
// };
